import React, { useState, useEffect, useCallback } from "react";
import EventsGalleryService from "../../../services/EventsGalleryService";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import "./TickerMaster.css";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  getTickerMasterDataById,
  insertUpdateTickerMaster,
} from "../../../helpers/API/APIEndPoints";
import { Redirect, useParams } from "react-router";
import { Encrypt } from "../../../helpers/Cryptography/CryptoJS";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory } from "react-router-dom";
import {
  failedToUpdateRecordMsg,
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const TickerMasterEdit = (props) => {
  // const { id: tickerId } = useParams();
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [Id, setId] = useState(0);

  const [name, setName] = useState("");
  const [sequence, setSequence] = useState("");
  const [oldSequence, setOldSequence] = useState(-1);
  const [link, setLink] = useState("");
  const [isActive, setIsActive] = useState(true);
  let formErrorObj = {};

  useEffect(() => {
    (async () => {
      let state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id !== 0 || state_id != "0") {
        getTickerMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getTickerMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getTickerMasterDataById, { id: id });

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].id) {
        let dataArr = data.data[0];
        let dataObj = dataArr[0];
        setId(dataObj.id);
        setName(dataObj.title);
        setSequence(dataObj.Sequence);
        setOldSequence(dataObj.Sequence);
        setLink(dataObj.Link);
        setIsActive(dataObj.IsActive);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        setLoading(true);
        let creator = getFromEncLocalStorage("userId");
        let requestParams = {
          id: Id == 0 ? null : Id,
          mode: Id ? "edit" : "create",
          name: name,
          sequence: sequence,
          oldSequence: oldSequence,
          link: link,
          isActive: isActive,
          createdBy: creator,
          modifiedBy: Id ? creator : null,
        };
        const res = await APICall(insertUpdateTickerMaster, requestParams);
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/ticker-master" });
          }
          setLoading(false);
        } else {
          notify(1, res.message ? res.message : failedToUpdateRecordMsg);
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/ticker-master" });
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    setName("");
    setSequence("");
    setLink("");
    formErrorObj = {};
  };

  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    switch (field) {
      case "name":
        setName(tempName);
        setError = "Ticker Name";
        break;
      case "sequence":
        setSequence(tempName);
        setError = "Sequence";
        break;
      case "link":
        setLink(tempName);
        break;
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const isValidUrl = (urlString) => {
    var inputElement = document.createElement("input");
    inputElement.type = "url";
    inputElement.value = urlString;

    if (!inputElement.checkValidity()) {
      return false;
    } else {
      return true;
    }
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";

    if (!name) {
      setError = "Ticker";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    }
    // else if (name.replace(/\s+/g, " ").trim().length >= 50) {
    //   setError = "Tickers";
    //   objError[setError.replaceAll(" ", "") + "_isEmpty"] =
    //     setError + " Is Longer Than The 50 Character";
    // }

    if (!sequence || !/^[0-9]+$/.test(sequence)) {
      setError = "Sequence";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Should Be Numeric";
    }

    if (
      link &&
      link != undefined &&
      link != null &&
      link.trim() != "" &&
      !isValidUrl(link)
    ) {
      setError = "Link";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " should be valid";
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  return (
    <>
      <Main active={"ticker_master/edit"} removeContainer={true}>
        <Loadspinner filename="TickerMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">Ticker Data</div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Ticker name</label> */}
                      <FormLabel value="Ticker name" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Ticker"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={name}
                        onChange={(e) => handleTextEvent(e, "name")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Ticker_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Ticker_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Sequence</label> */}
                      <FormLabel value="Sequence" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Sequence"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={sequence}
                        type="number"
                        onChange={(e) => handleTextEvent(e, "sequence")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Sequence_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Sequence_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Link</label> */}
                      <FormLabel value="Link" />
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Link"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={link}
                        onChange={(e) => handleTextEvent(e, "link")}
                      />

                      <ErrorLabel value={formErrors["Link_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-3 col-xs-3 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Active Status</label> */}
                      <FormLabel value="Active Status" />
                      <div className="custom-checkbox">
                        <input
                          disabled={editModeIsActive ? true : false}
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          checked={isActive}
                          className="isActive"
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <SubmitButton
                        onClick={(e) => onClickFunction(e, "Submit")}
                      />
                      {editModeDisableButton && (
                        <ResetButton
                          onClick={(e) => onClickFunction(e, "Reset")}
                        />
                      )}

                      <CancelButton
                        onClick={(e) => onClickFunction(e, "Cancel")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
};

export default TickerMasterEdit;
